export default __webpack_public_path__ + "static/media/img_9.7d0703c3.jpg";